import "./App.css";
import LoadingWindowsXp from "./pages/loading";

function App() {
	return (
		<div className="App" style={{ overflow: "hidden" }}>
			<LoadingWindowsXp />
			{/* <Home /> */}
			{/* <LogPage /> */}
		</div>
	);
}

export default App;
